<template>
  <div :class="classes(n())">
    <div :class="classes(n('left'))">
      <div :class="classes(n('icon-wrapper'))">
        <slot name="icon">
          <StepItemIcon :activated="isIconActivated">
            {{ $props.index + 1 }}
          </StepItemIcon>
        </slot>
      </div>
      <StepItemLine
        :activated="isLineActivated"
        :horizontal="false"
        :class="classes(n('line'))"
      />
    </div>
    <div :class="classes(n('right'))">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'virtual-vue';
import { stepItemProps } from '../props';
import { stepItemEmits } from '../item-emits';
import { createNamespace } from '../../utils/components';
import StepItemIcon from './icon.vue';
import StepItemLine from './line.vue';

const { name, n, classes } = createNamespace('step-item-vertical');

export default defineComponent({
  name,
  components: {
    StepItemIcon,
    StepItemLine,
  },
  props: stepItemProps,
  emits: stepItemEmits,
  setup(props) {
    /**
     * 是否激活图标（仅针对默认数字icon，如果传入了icon插槽，则不激活，激活：展示绿色实心圆，未激活：展示灰色实心圆）
     * 如果flow为true，则激活过的步骤图标都激活
     * 如果flow为false，则返回当前步骤是否激活
     */
    const isIconActivated = computed(() => props.active >= props.index);
    /**
     * 是否激活连线（激活：展示绿色实线，未激活：展示灰色虚线）
     * 如果flow为true，则当前步骤和前一步骤都激活时，连线才激活
     * 如果flow为false，则不激活连线
     */
    const isLineActivated = computed(() => props.active > props.index);

    return {
      n,
      classes,
      isIconActivated,
      isLineActivated,
    };
  },
});
</script>
